// src/layouts/RootGate.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAccountMeCached } from "lib/axios";

const LOGIN_PATH = "/portal/authentication/sign-in";
const BACK_TO_PORTAL = encodeURIComponent("/portal/dashboard?tab=app");

export default function RootGate() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    // Hard timeout so we never “sit” on /portal if the network hangs
    const failSafe = setTimeout(() => {
      if (!cancelled) {
        window.location.replace(`${LOGIN_PATH}?redirect=${BACK_TO_PORTAL}`);
      }
    }, 3000); // adjust if you want, but keep it short

    (async () => {
      try {
        // Treat 4xx as handled (don’t throw), only throw on 5xx/network
        const res = await getAccountMeCached({
          timeout: 6000,
          validateStatus: (s) => s < 500,
        });

        if (cancelled) return;
        clearTimeout(failSafe);

        if (res?.status !== 200 || !res?.data?.role) {
          // Not authed or unknown user → out to WP login
          window.location.replace(`${LOGIN_PATH}?redirect=${BACK_TO_PORTAL}`);
          return;
        }

        // ✅ Persist normalized role so nav can render instantly
        const role = String(res.data.role || "")
          .toLowerCase()
          .trim();
        try {
          localStorage.setItem("role", role);
        } catch {}

        switch (res.data.role) {
          case "admin":
            navigate("/dashboard?tab=app", { replace: true });
            break;
          case "analyst":
          case "client_admin":
          case "client_user":
          case "read_only":
            navigate("/dashboard?tab=app", { replace: true });
            break;
          default:
            window.location.replace(`${LOGIN_PATH}?redirect=${BACK_TO_PORTAL}`);
        }
      } catch {
        // Network / 5xx → just go to login
        window.location.replace(`${LOGIN_PATH}?redirect=${BACK_TO_PORTAL}`);
      }
    })();

    return () => {
      cancelled = true;
      clearTimeout(failSafe);
    };
  }, [navigate]);

  return null; // no UI
}
